import {Component} from '@angular/core';
import {MainRoute} from 'src/app/models/MainRoute';
import {RoutingService} from 'src/app/services/Routing.service';
import {TranslatePipe} from '@ngx-translate/core';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  imports: [
    TranslatePipe,
    RouterLink
  ],
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {

  currentRoute: MainRoute;

  constructor() {
    this.currentRoute = RoutingService.getStationRoute();
  }
}
